import React from "react";
import { string, arrayOf, node, oneOfType, object } from "prop-types";
import classNames from "classnames/bind";
import { CompareTable } from "./CompareTable";
// eslint-disable-next-line import/no-cycle
import { Modal } from "../Modal";
import * as styles from "./CompareTableModal.module.scss";

const cx = classNames.bind(styles);

const CompareTableModal = ({ children, header, rows, title }) => (
	<Modal contentLabel="content details" simple>
		<Modal.Trigger className={cx("triggerWrapper")}>
			<div className={cx("trigger")}>{children}</div>
		</Modal.Trigger>
		<Modal.Content>
			<CompareTable header={header} rows={rows} title={title} />
		</Modal.Content>
	</Modal>
);

CompareTableModal.propTypes = {
	children: oneOfType([arrayOf(node), node]).isRequired,
	rows: arrayOf(object).isRequired,
	header: arrayOf(object).isRequired,
	title: string,
};
CompareTableModal.defaultProps = {
	title: "",
};

export default CompareTableModal;
export { CompareTableModal };
